import './Highlight.css';
export var wrapper = '_lajjl30-3-8-0';